// extracted by mini-css-extract-plugin
module.exports = {"welcomeBottom":"_2z5hEPS8","greetingContainer":"_1jrR8aBy","Greeting":"_3oi2Dbi-","Welcome":"_2ImI2lWe","Image":"_3VZaEfCC","Email":"qe5MxBIQ"};
    if(module.hot) {
      // 1746735810221
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  